<script>
    import { Router, Route, Link } from "svelte-navigator";
    import Slider from "../components/Slider.svelte";
    import TopCats from "../components/TopCats.svelte";
    import TopProducts from "../components/TopProducts.svelte";
    import TopWhiskeys from "../components/TopWhiskeys.svelte";
    import BottlesBar from "../components/BottlesBar.svelte";
    import StickyHeader from "../components/StickyHeader.svelte";
    import Footer from "../components/Footer.svelte";
    import TopWines from "../components/TopWines.svelte";

    let showHeader = false;

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () {
        myFunction();
    };

    // Get the header
    var header = document.getElementById("stickyHeader");

    // Get the offset position of the navbar
    var sticky = 10;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
        if (window.pageYOffset > sticky) {
            showHeader = true;
        } else {
            showHeader = false;
        }
    }
</script>

<main>
    <Router>
        <Slider />
        <div class="mainContainer">
            <!-- sticky header -->
            <div id="stickyHeader" class="stickyHeader">
                {#if showHeader}
                    <StickyHeader />
                {/if}
            </div>
            <!-- sticky header -->

            <div class="ui stackable grid">
                <div class="re sixteen wide column">
                    <TopProducts />
                </div>

                <div class="re sixteen wide column">
                    <TopWhiskeys />
                </div>

                <div class="re sixteen wide column">
                    <TopWines />
                </div>

                <div class="orang sixteen wide column">
                    <BottlesBar />
                </div>
            </div>
        </div>
        <Footer />
    </Router>
</main>

<style>
    .grid {
        min-height: 25em;
        padding-top: 2em;
        font-size: 10px;
        max-width: 110em;
        margin: auto !important;
    }
</style>
